var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3264dc;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 44,
    height: 44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.281,28.961l-6.137-6.155a23.828,23.828,0,0,1,3.223,1.384A5.5,5.5,0,0,1,35.281,28.961Zm2.167,7.321L34.88,38.85l-4.753-4.735H6.143V29.052a5.41,5.41,0,0,1,2.932-4.844,25.947,25.947,0,0,1,8.5-2.641L1.39,5.378,3.958,2.81ZM26.485,30.473l-5.463-5.463h-.31a22.051,22.051,0,0,0-9.98,2.44,1.769,1.769,0,0,0-.947,1.6v1.42ZM20.712,8.619a3.638,3.638,0,0,1,1.275,7.048l2.7,2.7A7.28,7.28,0,1,0,14.611,8.292l2.7,2.7A3.622,3.622,0,0,1,20.712,8.619Z",
    transform: "translate(1.141 2.307)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.5924574ed3459b5d70bf21e1251d18d4.svg";
export { ForwardRef as ReactComponent };